import THEMES from 'src/themes';
import { AppSubdomains } from 'src/types/common';
import { getSubdomain } from 'src/utils/domain/getSubdomain';

export default function getTheme() {
  const subdomain = getSubdomain(AppSubdomains, AppSubdomains.Pari);

  return THEMES[subdomain];
}
